import { motion } from 'framer-motion';
import { TransactionTable } from '../../ComponentTypes/ProductTable';
import ProductContext from '../../memory/ProductContext';

class LoadingMiddlewareTable extends TransactionTable {
  constructor(props: any) {
    super(props);
  }

  public override tBodyComp() {
    return (
      <tbody {...this.props.getTableBodyProps()} className={this.stylingTBodyComp}>
        {this.rows.map((row: any, i: any) => {
          this.prepareRow(row);
          return this.trComp(row, i);
        })}
      </tbody>
    );
  }
}

export default LoadingMiddlewareTable;
